import React from 'react';
import { Save } from 'lucide-react';

interface AdminHeaderProps {
  isDirty: boolean;
  publish: () => void;
}

export const AdminHeader: React.FC<AdminHeaderProps> = ({ isDirty, publish }) => {
  return (
    <header className="bg-[#0F172A]/40 backdrop-blur-xl border-b border-white/[0.05] p-4 px-8 flex justify-between items-center z-20">
      <div className="flex items-center gap-4">
        <div className="w-1.5 h-1.5 rounded-full bg-[#14B8A6] shadow-[0_0_8px_rgba(20,184,166,0.5)] animate-pulse"></div>
        <span className="text-[10px] font-semibold tracking-[0.2em] text-slate-400 uppercase">
          Sistema <span className="text-[#14B8A6] ml-1">Ativo</span>
        </span>
      </div>
      <div className="flex items-center gap-8">
         {isDirty && (
           <div className="flex items-center gap-2">
             <div className="w-1.5 h-1.5 rounded-full bg-[#F59E0B] animate-ping"></div>
             <span className="text-[10px] text-[#F59E0B] uppercase tracking-widest font-bold">Alterações Pendentes</span>
           </div>
         )}
         <button 
           onClick={publish}
           className={`
             text-[11px] uppercase tracking-[0.2em] font-black transition-all duration-500 px-8 py-2.5 rounded-full flex items-center gap-2
             ${isDirty 
                ? 'text-[#020617] bg-[#14B8A6] hover:bg-[#5EEAD4] shadow-[0_0_20px_rgba(20,184,166,0.4)] animate-pulse' 
                : 'text-slate-600 border border-white/5 cursor-not-allowed'}
           `}
           disabled={!isDirty}
         >
           <Save size={14} />
           {isDirty ? 'Publicar no Site' : 'Dados Sincronizados'}
         </button>
      </div>
    </header>
  );
};
